import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface EditorialSectionDividerProps {
  className?: string;
}

const EditorialSectionDivider: React.FC<EditorialSectionDividerProps> = ({ className = '' }) => {
  const { theme } = useTheme();
  const dividerColor = theme === 'dark' ? '#333333' : '#E0E0E0';
  
  return (
    <div className={`w-full ${className}`}>
      <div 
        className="w-full h-px"
        style={{ 
          background: `linear-gradient(to right, transparent, ${dividerColor} 15%, ${dividerColor} 85%, transparent)` 
        }}
      />
    </div>
  );
};

export default EditorialSectionDivider;
